/**
 *
 * NotesLanding
 *
 */

import $ from 'jquery';

export const DownloadModalMixin = {
  name: 'DownloadModalMixin',

  data: () => {
    return {
      $downloadModal: null,
    };
  },

  methods: {
    callbackOnModalShow() {
      //
    },

    callbackOnModalHidden() {
      //
    },
  },

  mounted() {
    this.$downloadModal = $(this.$refs.downloadModal);
    this.$downloadModal.on('show.bs.modal', this.callbackOnModalShow);
    this.$downloadModal.on('hidden.bs.modal', this.callbackOnModalHidden);
  },

  beforeDestroy() {
    this.$downloadModal.modal('hide');
  },
};
